import React, { useState, useEffect, createContext ,useCallback} from "react";
import "./App.css";
import Login from "./components/Login";
import MintPage from "./components/MintPage";
import Particles from "react-tsparticles";
import { loadFull } from "tsparticles";
import background from './assets/animation/background.json'
import { useAccount, useConnect, useDisconnect, useSwitchNetwork } from "wagmi";
import { Toast, ToastContainer } from "react-bootstrap";

export const appContext = createContext();

function App() {
  const {disconnect} = useDisconnect()
  const { isConnected} = useAccount({onConnect({connector}){
    connector.getChainId().then((id)=>{
      if(id!==19){
        console.log('chain id',id)
        disconnect()
        setShowToast(true)
      }
    })
  }})

  useEffect(() => {
    console.log(isConnected)
  }, [isConnected]);

  const contractAddress = "0x365d12ba05885A94EF908AbfD5ef6aECD2bbd10e";
  const [saleComplete, setSaleComplete] = useState(null);
  const [showToast, setShowToast] = useState(false)

  //mobile check
  var width = document.documentElement.clientWidth
  // less clustered bg
  if(width<500){
    background['particles']["number"]['value']=50
  }

  const particlesInit = useCallback(async engine => {
    await loadFull(engine);
  }, []);

  return (

    <appContext.Provider
      value={[
        contractAddress,
        saleComplete, setSaleComplete
      ]
      }
    >
      <>
        <Particles params={background} init={particlesInit} />
        <ToastContainer className="p-3" position="top-center">
          <Toast onClose={() => { setShowToast(false) }} show={showToast} delay={3000} autohide>
            <Toast.Body>
              Incorrect Chain
            </Toast.Body>
          </Toast>
        </ToastContainer>
        <div className="App">
          {isConnected ?
            <div>
              <MintPage />
            </div>
            :
            <div>
              <Login />
            </div>
          }

        </div>
      </>
    </appContext.Provider>
  );

}

export default App;

